import { ArrowRightOutlined } from '@ant-design/icons';
import Form from 'antd/lib/form';
import Space from 'antd/lib/space';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';
import Alert from 'antd/lib/alert';
import Tooltip from 'antd/lib/tooltip';
import Text from 'antd/lib/typography/Text';
import { useForm } from 'antd/lib/form/Form';
import { isEqual } from 'lodash';
import * as React from 'react';
import { SetupViewProps } from '../../../../typescriptHelpers';
import { WORKING_BRANCH_FIELD_RULES } from '../../../AdditionalBranchesComponent';
import { runwayColors } from '../../../styles/globalStyles';
import { InfoCircleOutlined } from '@ant-design/icons';

export interface WorkingBranchNameModuleProps extends SetupViewProps {
    workingBranch?: string;
    workingBranchGuess?: string;
    isLoadingWorkingBranchGuess?: boolean;
    setAdditionalBranchesIsLoading: boolean;
    setAdditionalBranches: (values) => void;
}
export const WorkingBranchNameModule: React.FC<WorkingBranchNameModuleProps> = ({
    onChange,
    workingBranch,
    workingBranchGuess,
    isLoadingWorkingBranchGuess,
    setAdditionalBranches,
    setAdditionalBranchesIsLoading,
}) => {
    const [form] = useForm();

    const initialValues = {
        workingBranch,
    };

    const checkIfHasUnsavedChanges = () => {
        const formValues = form.getFieldsValue();
        return !isEqual(formValues, initialValues);
    };

    const onApplySuggestionButton = () => {
        form.setFieldsValue({ workingBranch: workingBranchGuess });
        onChange(checkIfHasUnsavedChanges());
    };

    return (
        <Form
            form={form}
            onFinish={setAdditionalBranches}
            initialValues={initialValues}
            onFieldsChange={() => onChange(checkIfHasUnsavedChanges())}
        >
            <Space direction="vertical" style={{ width: '100%' }} size={20}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Form.Item style={{ flex: 1, maxWidth: 300, marginBottom: 0 }}>
                        <Form.Item noStyle name="workingBranch" rules={WORKING_BRANCH_FIELD_RULES}>
                            <Input placeholder="main" autoComplete="off" />
                        </Form.Item>

                        {isLoadingWorkingBranchGuess && <Spin size="small" />}
                        {workingBranchGuess && (
                            <Alert
                                style={{
                                    marginTop: '1em',
                                    marginBottom: '1em',
                                    backgroundColor: `${runwayColors.primary}10`,
                                    border: `1px solid ${runwayColors.primary}50`,
                                }}
                                message={
                                    <>
                                        Suggested:{' '}
                                        <Text code style={{ margin: '1em' }}>
                                            {workingBranchGuess}
                                        </Text>
                                        <Tooltip title="Suggestion for this field based on the branches we found in your repository">
                                            <InfoCircleOutlined
                                                style={{
                                                    color: runwayColors.info,
                                                }}
                                            />
                                        </Tooltip>
                                    </>
                                }
                                action={
                                    <Button size="small" onClick={onApplySuggestionButton}>
                                        Apply
                                    </Button>
                                }
                            />
                        )}
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0 }} shouldUpdate>
                        {() => (
                            <Button
                                loading={setAdditionalBranchesIsLoading}
                                disabled={!checkIfHasUnsavedChanges()}
                                type="primary"
                                htmlType="submit"
                                icon={<ArrowRightOutlined />}
                            >
                                Save
                            </Button>
                        )}
                    </Form.Item>
                </div>
            </Space>
        </Form>
    );
};
